module.exports = __webpack_public_path__ + "img/27.10.pH.872ac8cb.png";